import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import {
  normalizarTextoCategoria,
  ordenarCategoriasPorConfiguracion,
} from "../utils/categorias";

function useCategoriasOrdenadas({
  categoriasDetectadas = [],
  turnoActivo = "",
} = {}) {
  const [categoriasConfiguradas, setCategoriasConfiguradas] = useState([]);
  const [cargandoCategorias, setCargandoCategorias] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "categorias"), orderBy("orden", "asc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        console.log("SNAPSHOT CATEGORÍAS:", snapshot.size);
        const categorias = snapshot.docs.map((documento) => ({
          id: documento.id,
          ...documento.data(),
        }));

        setCategoriasConfiguradas(categorias);
        setCargandoCategorias(false);
      },
      (error) => {
        console.error(
          "Error cargando categorías ordenadas:",
          error.code,
          error.message,
          error,
        );
        setCategoriasConfiguradas([]);
        setCargandoCategorias(false);
      },
    );

    return () => unsubscribe();
  }, []);

  const categoriasOrdenadas = useMemo(() => {
    return ordenarCategoriasPorConfiguracion(
      categoriasDetectadas,
      categoriasConfiguradas,
      turnoActivo,
    );
  }, [categoriasDetectadas, categoriasConfiguradas, turnoActivo]);

  const mapaCategoriasConfiguradas = useMemo(() => {
    const mapa = new Map();

    categoriasConfiguradas.forEach((categoria) => {
      mapa.set(normalizarTextoCategoria(categoria.nombre), categoria);
    });

    return mapa;
  }, [categoriasConfiguradas]);

  return {
    categoriasOrdenadas,
    categoriasConfiguradas,
    mapaCategoriasConfiguradas,
    cargandoCategorias,
  };
}

export default useCategoriasOrdenadas;
